import React from 'react';
import { observer } from 'mobx-react';

import { FieldSet } from 'app/component/fieldset/FieldSet';
import { EmploymentFormStore } from 'app/logic/pages/employment/EmploymentFormStore';
import { ActivityFieldCodeFormItem } from 'app/logic/pages/employment/ActivityFieldCodeFormItem';
import { MonthIncomeFormItem } from 'app/logic/pages/employment/MonthIncomeFormItem';
import { ExperienceSelectFormItem } from 'app/logic/pages/employment/ExperienceSelectFormItem';

export interface IJobDetailsForm {
    /**
     * Хранилище состояния формы ввода сведений о работе.
     */
    formStore: EmploymentFormStore;
}

/**
 * Набор полей отвечающий за ввод деталей трудоустройства опльзователя.
 */
export const JobDetailsForm = observer(({ formStore }: IJobDetailsForm) => {
    return (
        <FieldSet
            className={'jobDetailsFieldSet'}
            fieldsProps={[
                {
                    className: 'monthIncome',
                    title: '',
                    value: <MonthIncomeFormItem formStore={formStore} />,
                },
                {
                    className: 'activityFieldCode',
                    title: '',
                    value: <ActivityFieldCodeFormItem formStore={formStore} />,
                    isVisible: !formStore.isUnemployedPensioner,
                },
                {
                    className: 'experience',
                    title: '',
                    value: <ExperienceSelectFormItem formStore={formStore} />,
                    isVisible: !formStore.isUnemployedPensioner,
                },
            ]}
        />
    );
});
